import { Component, computed, inject, Input, input, model } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE, FILE_TYPE, INJECT_TYPE } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { FileInterface } from 'src/model/file.interface';
import { FileService } from 'src/services/file.service';

@Component({
  selector: 'app-image-viewer',
  standalone: false,
  templateUrl: './image-viewer.component.html',
  styleUrl: './image-viewer.component.scss',
})
export class ImageViewerComponent {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private sharedService = inject(SharedService);
  private fileService = inject(FileService);

  @Input() injectContent: DialogItem[];
  INJECT_TYPE = INJECT_TYPE;

  canDelete = input<boolean>(false);
  fileArr = model<FileInterface[]>([]);
  imgArr = computed(() => this.fileArr().filter(f => f.fileType === FILE_TYPE.IMAGE));
  index = model(0);
  currentImage = computed(() => this.imgArr()[this.index()]);

  rotateDegree: number = 0;

  get imageLink() {
    return this.restApi.apiUrl + this.currentImage().url;
  }

  rotate() {
    this.rotateDegree = (this.rotateDegree == 270) ? 0 : this.rotateDegree + 90;
    const rotateStr = "rotate(" + this.rotateDegree + "deg)";
    const img = document.getElementById('enlarged-image');
    if (img) img.style.transform = rotateStr;
  }

  reset() {
    this.activeModal.close();
  }

  async confirmDelete(): Promise<boolean> {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = `Are you sure you want to delete this image?`;
    return modalRef.result;
  }

  async deleteImage(url: string) {
    const confirm = await this.confirmDelete();
    if (confirm) {
      const deleted = await this.fileService.deleteFile(url);
      if (deleted) {
        this.fileArr.update(list => {
          list.splice(this.index(), 1);
          return [...list];
        });
        this.sharedService.openAlert('Successfully deleted image!', ALERT_TYPE.SUCCESS);
        this.reset();
      }
    }
  }
}
